import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Popup } from "semantic-ui-react";

export const Section6 = () => {
  const { t } = useTranslation();
  const [isShow, setIsShow] = useState(false);
  const [popup, showPopup] = useState(false);
  const [detailId, setShowDetail] = useState(null);
  const totalImg = 15;

  function mod(n, m) {
    return ((n % m) + m) % m;
  }

  useEffect(() => {
    function onScroll() {
      let distance = window.scrollY;
      if (distance > 28000 && !isShow) {
        setIsShow(true);
      }
    }
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <div className="w-screen h-full bg-[#2E3840] text-white mt-14">
      <div className="">
        <div className="text-3xl font-inter-bold text-center py-8">
          {t("Album")}
        </div>
        <div
          className={`self-center gap-8 ${
            isShow && "team-appear-anim anim-delay-1"
          } opacity-0`}
        >
          <img src="/assets/culture/all.webp" alt="all" className="w-full" />
        </div>
      </div>
      <div className="py-8">
        <div className="bg-[#F1234A] p-4 cursor-pointer w-[180px] text-center te rounded-lg mx-auto">
          <div
            className="text-white text-sm md:text-lg font-inter-semibold"
            onClick={() => {
              showPopup(true);
            }}
          >
            {t("View all")}
          </div>
        </div>
      </div>
      <Modal
        style={{
          width: "unset !important",
          width: "84vw",
        }}
        closeIcon={
          <div className="relative">
            <img
              src="/assets/icon/close_big.webp"
              alt="close"
              className="w-6 h-6 bg-black text-white rounded-3xl p-1 absolute right-5 top-4 cursor-pointer"
              onClick={() => {
                showPopup(false);
                setShowDetail(null);
              }}
            />
          </div>
        }
        open={popup}
      >
        <div className="w-full h-full pb-8 md:pb-20 bg-white rounded-lg">
          <div className="py-4 text-center text-xl font-inter-bold">
            {t("Album")}
          </div>
          {detailId !== null && (
            <div
              className="absolute top-5 left-5 hover:text-blue-500 cursor-pointer"
              onClick={() => {
                setShowDetail(null);
              }}
            >
              {"<-"} {t("Back")}
            </div>
          )}
          {detailId == null ? (
            <div
              className="grid grid-cols-2 
              md:grid-cols-5 gap-2 justify-center px-6
              min-h-[400px]
             max-h-[80vh] overflow-y-scroll"
            >
              {Array.from({ length: 14 }).map((i, idx) => {
                return (
                  <img
                    onClick={() => {
                      setShowDetail(idx);
                    }}
                    src={`/assets/culture/album${idx}.webp`}
                    className="cursor-pointer"
                    alt="product"
                  />
                );
              })}
            </div>
          ) : (
            <div className="px-6">
              <div className="relative flex">
                <img
                  src={`/assets/culture/album${detailId}.webp`}
                  className="cursor-pointer h-[400px] object-contain border-black border-[1px] w-full"
                  alt="product"
                />
                <div
                  className="absolute bottom-0 text-white w-full text-center py-2"
                  style={{
                    background: "rgba(0, 0, 0, 0.5)",
                  }}
                >
                  {t(`title_culture_${detailId}`)}
                </div>
                <div className="self-center justify-center">
                  <img
                    src="/assets/icon/left.webp"
                    className="absolute left-4 -translate-y-1/2 w-10 h-10 cursor-pointer"
                    alt="left"
                    onClick={() => {
                      setShowDetail(mod(detailId - 1, totalImg));
                    }}
                  />
                  <img
                    src="/assets/icon/right.webp"
                    className="absolute right-4 -translate-y-1/2 w-10 h-10 cursor-pointer"
                    alt="right"
                    onClick={() => {
                      setShowDetail(mod(detailId + 1, totalImg));
                    }}
                  />
                </div>
              </div>
              <div className="hidden md:grid grid grid-cols-5 gap-4 justify-center mt-6">
                {Array.from({ length: 5 }).map((i, idx) => {
                  return (
                    <img
                      onClick={() => {
                        setShowDetail(mod(idx + detailId - 2, totalImg));
                      }}
                      src={`/assets/culture/album${mod(
                        idx + detailId - 2,
                        totalImg
                      )}.webp`}
                      className={`cursor-pointer opacity-60 hover:opacity-100 rounded-lg ${
                        idx === 2 && "active-img-culture"
                      }`}
                      alt="product"
                    />
                  );
                })}
              </div>
              <div className="grid md:hidden grid grid-cols-3 gap-4 justify-center mt-6">
                {Array.from({ length: 3 }).map((i, idx) => {
                  return (
                    <img
                      onClick={() => {
                        setShowDetail(mod(idx + detailId - 1, totalImg));
                      }}
                      src={`/assets/culture/album${mod(
                        idx + detailId - 1,
                        totalImg
                      )}.webp`}
                      className={`cursor-pointer opacity-60 hover:opacity-100 rounded-lg ${
                        idx === 1 && "active-img-culture"
                      }`}
                      alt="product"
                    />
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};
